/**
 * WebHeader — the web app's brand cluster for the shared `Header`.
 *
 * Derived from v35 `.app-header-left`: NU logo + "NU Assist" wordmark
 * with the accent period. The shared `Header` primitive owns the bar
 * chrome; this composes only what goes in its `brand` slot.
 */
import { BrandWordmark } from "./BrandWordmark";

export interface WebHeaderBrandProps {
  /** Click → home. Wired by the shell composition. */
  onHome?: () => void;
}

export function WebHeaderBrand({ onHome }: WebHeaderBrandProps) {
  return (
    <button
      type="button"
      onClick={onHome}
      aria-label="NU Assist — home"
      data-testid="web-header-brand"
      className="flex items-center gap-2 bg-transparent border-0 p-0 cursor-pointer outline-none rounded-sm focus-visible:ring-2 focus-visible:ring-accent-muted"
    >
      <BrandWordmark />
    </button>
  );
}
